/* Swipe-indicator (dots) onder de PDP-galerij op mobiel.
   Eigen implementatie op de publieke css-slider-API ('change'-event +
   changeSlide()) — het ingebouwde dots-pad van de slider rendert in dit
   thema niet. Desktop houdt de thumbnails; CSS beperkt dit tot mobiel. */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-js-product-gallery] css-slider, .product-gallery css-slider').forEach(function (slider) {
      if (slider.dataset.pdpDotsBound) return;
      var items = slider.querySelectorAll('.product-gallery-item');
      if (items.length < 2) return;
      slider.dataset.pdpDotsBound = '1';

      var nav = document.createElement('div');
      nav.className = 'pdp-gallery-dots';
      nav.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < items.length; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pdp-gallery-dots__dot';
        dot.dataset.index = i;
        dot.tabIndex = -1;
        nav.appendChild(dot);
      }
      slider.insertAdjacentElement('afterend', nav);

      var dots = nav.querySelectorAll('.pdp-gallery-dots__dot');
      function update() {
        var idx = typeof slider.index === 'number' ? slider.index : 0;
        dots.forEach(function (d, i) {
          d.classList.toggle('pdp-gallery-dots__dot--active', i === idx);
        });
      }
      slider.addEventListener('change', update);
      slider.addEventListener('ready', update);
      nav.addEventListener('click', function (e) {
        var d = e.target.closest('.pdp-gallery-dots__dot');
        if (d && typeof slider.changeSlide === 'function') slider.changeSlide(d.dataset.index);
      });
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
